import React, { createContext, useState } from 'react'

export const addcontext = createContext()
function ContextShare({children}) {
    const [NavSelected,setNavSelected]=useState(false)
    const [ContactOpened,setContactOpened]=useState(false)
  return (
    <addcontext.Provider value={{NavSelected,setNavSelected,ContactOpened,setContactOpened}}>
        {children}
    </addcontext.Provider>
  )
}

export default ContextShare